export const ACCOUNTING_AUTHORIZED_ROLES = [
  process.env.REACT_APP_ADMIN_ROLE,
  process.env.REACT_APP_ACCOUNTING_ROLE,
];

export const ADMIN_AUTHORIZED_ROLES = [process.env.REACT_APP_ADMIN_ROLE];
